/** Returns whether a skill-test attempt meets the pass threshold. */
export function isSkillTestPassed(score: number, totalMarks: number, passingMarks = 0): boolean {
  const s = Number(score) || 0;
  const total = Number(totalMarks) || 0;
  const passing = Number(passingMarks) || 0;

  if (passing <= 0) return s > 0;

  // When passing marks exceed the test total (e.g. 80 on a 40-mark test), treat as percentage.
  if (total > 0 && passing > total && passing <= 100) {
    return (s / total) * 100 >= passing;
  }

  return s >= passing;
}

export function resolvePassMeta(attempt: any) {
  const score = attempt?.score ?? 0;
  const totalMarks = attempt?.totalMarks || attempt?.testMeta?.totalMarks || attempt?.test?.totalMarks || 0;
  const passingMarks = attempt?.testMeta?.passingMarks ?? attempt?.test?.passingMarks ?? 0;
  return { score, totalMarks, passingMarks, passed: isSkillTestPassed(score, totalMarks, passingMarks) };
}
